import { IonIcon } from '@ionic/react'
import { reloadOutline } from 'ionicons/icons'
import { clsx, cssClass } from 'yet-another-react-lightbox'

interface RotateButtonProps {
  rotating: boolean
  onClick: () => void
  disabled: boolean
}

export function RotateButton({
  rotating,
  onClick,
  disabled,
}: RotateButtonProps) {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={clsx('rotate-button', rotating && cssClass('pulsate'))}
      style={{
        background: 'transparent',
        border: 'none',
        cursor: 'pointer',
        padding: '8px',
        borderRadius: '4px',
        color: 'white',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
      aria-label='Rotate image'
    >
      <IonIcon icon={reloadOutline} style={{ width: '24px', height: '24px' }} />
    </button>
  )
}
